export enum STUDENT_TEST_TYPES {
  CARDIAC_TEST = '01',
  RUN_TEST = '02',
}
